export const deepClone = <T>(toClone: T): T => {
  return JSON.parse(JSON.stringify(toClone)) as T;
};

/**
 * Sorts a list of items by a given field, comparing the field values as strings.
 *
 * @typeParam T - The type of the items contained in the input array.
 * @param array - The array of items to sort. This array is not mutated.
 * @param field - The key of {@link T} whose value will be used for sorting. The
 *   field's values are converted to strings and compared using `localeCompare`.
 * @returns A new array containing the items from {@link array}, sorted
 *   alphabetically by the specified {@link field}.
 */
export function sortByStringField<T>(array: T[], field: keyof T): T[] {
  return [...array].sort((a, b) => {
    const aValue = a[field] as unknown;
    const bValue = b[field] as unknown;
    const aIsNullish = aValue == null;
    const bIsNullish = bValue == null;
    if (aIsNullish && bIsNullish) {
      return 0;
    }
    if (aIsNullish) {
      // Place null/undefined values after defined values
      return 1;
    }
    if (bIsNullish) {
      // Place null/undefined values after defined values
      return -1;
    }
    return String(aValue).localeCompare(String(bValue));
  });
}
